// Components/Unauthorised.jsx
import React from "react";

const Unauthorised = () => (
  <div className="unauthorised-page">
    <h2>403 - Unauthorised Access</h2>
    <p>You do not have permission to view this page.</p>
  </div>
);

export default Unauthorised;
